import { useGetOnboardingStatus } from "@src/components/onboarding/queries/get-onboarding-status";
import { OnboardingStep, StepsFilter } from "@src/gql/graphql";
import { captureOnboardingCompleted } from "@src/utils/analytics";
import { useEffect, useRef } from "react";

function useAfterOnboarding() {
	const { data } = useGetOnboardingStatus(StepsFilter.All);

	if (!data) return undefined;

	const introVideosSteps = data.steps.find(
		(step) => step.step === OnboardingStep.IntroVideos,
	);

	return introVideosSteps?.isCompleted ?? false;
}

export function AfterOnboarding() {
	const isOnboardingComplete = useAfterOnboarding();
	const prevIsOnboardingCompleteRef = useRef<boolean | undefined>(undefined);

	useEffect(() => {
		// Skip until data has loaded
		if (isOnboardingComplete === undefined) return;

		if (
			prevIsOnboardingCompleteRef.current === false &&
			isOnboardingComplete === true
		) {
			captureOnboardingCompleted();
		}
		prevIsOnboardingCompleteRef.current = isOnboardingComplete;
	}, [isOnboardingComplete]);

	return null;
}
